export default function Footer() {
  const footerNav = [
    { label: '精彩推荐', href: '#media' },
    { label: '热播精选', href: '#cards' },
    { label: '专题聚焦', href: '#carousel' },
    { label: '热度榜单', href: '#ranking' },
    { label: '分类索引', href: '#index' },
    { label: '平台优势', href: '#features' },
    { label: '常见问题', href: '#faq' },
    { label: '最新动态', href: '#updates' },
  ];

  return (
    <footer id="footer" className="pt-16 md:pt-20 pb-8 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-screen-2xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
                木
              </span>
              <span className="text-xl font-heading text-white">木瓜影视</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              木瓜影视在线观看平台，免费在线直接看最新电视剧电影，
              网页看视频高清不缓冲，即点即播无需下载注册。
              每日更新2000+高清影视资源，覆盖全品类影视内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerNav.slice(0, 4).map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">更多内容</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerNav.slice(4).map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              感谢所有合作伙伴对木瓜影视的支持与信任。合作详情请联系我们的商务团队。
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 mt-3 text-sm text-primary-300 hover:text-primary-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              商务合作
            </a>
          </div>
        </div>

        <div className="pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-500">
          <span>&copy; 2023-2026 木瓜影视 mugua.movie 版权所有</span>
          <div className="flex items-center gap-4">
            <a href="#hero" className="hover:text-primary-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" className="hover:text-primary-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="hover:text-primary-300 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}